import * as React from "react";

export interface SafariProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Optional URL to display in the address bar */
  url?: string;
}

export function Safari({ url = "www.suaagenda.com.br", className = "", children, ...props }: SafariProps) {
  return (
    <div
      className={`overflow-hidden rounded-xl border border-neutral-200 bg-white shadow-md ${className}`}
      {...props}
    >
      <div className="flex h-11 items-center gap-2 border-b border-neutral-200 bg-neutral-100 px-4">
        <div className="flex gap-1.5">
          <span className="h-3 w-3 rounded-full bg-red-500" />
          <span className="h-3 w-3 rounded-full bg-yellow-500" />
          <span className="h-3 w-3 rounded-full bg-green-500" />
        </div>
        <div className="mx-auto flex-1">
          <div className="mx-auto h-6 w-full max-w-md rounded-md border border-neutral-300 bg-white px-3 text-xs leading-6 text-neutral-700">
            {url}
          </div>
        </div>
      </div>
      <div className="bg-white">{children}</div>
    </div>
  );
}

export default Safari;
